var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#C26900",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1243 17.1622C40.9943 17.0589 40.843 16.9871 40.6818 16.9523C40.5206 16.9175 40.3538 16.9207 40.1939 16.9615L31.9032 19.0762L23.5826 14.8303C23.3507 14.7123 23.0852 14.6828 22.8339 14.7472L14.1539 16.9615C13.9192 17.0214 13.7108 17.1596 13.5619 17.3542C13.413 17.5488 13.3321 17.7886 13.332 18.0354V37.964C13.3321 38.1322 13.3697 38.2983 13.442 38.4495C13.5143 38.6006 13.6194 38.733 13.7494 38.8365C13.8793 38.9401 14.0307 39.012 14.192 39.0469C14.3532 39.0818 14.5202 39.0787 14.6801 39.0379L22.9709 36.9233L31.2915 41.1692C31.4425 41.2452 31.6086 41.2849 31.777 41.2854C31.8657 41.2854 31.9541 41.2742 32.0401 41.2522L40.7201 39.0379C40.9549 38.9781 41.1633 38.8399 41.3122 38.6453C41.4611 38.4507 41.542 38.2109 41.542 37.964V18.0354C41.5421 17.8671 41.5045 17.7009 41.4321 17.5496C41.3597 17.3982 41.2544 17.2657 41.1243 17.1622ZM24.182 17.612L30.692 20.9334V38.3875L24.182 35.0661V17.612ZM15.502 18.9004L22.012 17.2397V34.8848L15.502 36.5455V18.9004ZM39.372 37.0991L32.862 38.7598V21.1147L39.372 19.454V37.0991Z",
    fill: "#C26900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6fc58b72051340313060ded130b5fafb.svg";
export { ForwardRef as ReactComponent };